import { render, staticRenderFns } from "./classify-contact-add.vue?vue&type=template&id=fd8a0b4a&scoped=true&"
import script from "./classify-contact-add.vue?vue&type=script&lang=js&"
export * from "./classify-contact-add.vue?vue&type=script&lang=js&"
import style0 from "./classify-contact-add.vue?vue&type=style&index=0&id=fd8a0b4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd8a0b4a",
  null
  
)

export default component.exports